module.exports = __webpack_public_path__ + "img/BMGInventedHardwareToCloseResorptionGaps.2f53d183.jpg";